import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ModalInfoType } from '@components/molecules/modal/Modal'

import type { InquiryStateType } from '@redux/types'

// initial state
const initialState: InquiryStateType = {
	triggerInitInquiryPage: false,
	triggerSendInquiry: false,
	isSendingInquiry: false,

	showModal: false,
	modalInfo: {
		target: '',
		title: '',
	},

	insertInquiry: {
		name: '',
		email: '',
		categ: '',
		message: '',
	},
	inquiryErrorMessage: {
		name: '',
		email: '',
		categ: '',
		message: '',
	},
}

const slice = createSlice({
	name: 'inquiry',
	initialState,
	reducers: {
		TRIGGER_INIT_INQUIRY_PAGE: (
			state: InquiryStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitInquiryPage = action.payload
		},
		TRIGGER_SEND_INQUIRY: (state: InquiryStateType, action: PayloadAction<boolean>) => {
			state.triggerSendInquiry = action.payload
		},
		// 첨부 이미지(File)는 직렬화되지 않아 상태에 두지 않는다 — 액션으로 사가에만 넘긴다(UPLOAD_PROFILE_IMAGE 와 같은 방식)
		SEND_INQUIRY: (
			state: InquiryStateType,
			action: PayloadAction<{ files: File[] }>,
		) => {},
		IS_SENDING_INQUIRY: (state: InquiryStateType, action: PayloadAction<boolean>) => {
			state.isSendingInquiry = action.payload
		},

		SHOW_MODAL: (state: InquiryStateType, action: PayloadAction<boolean>) => {
			state.showModal = action.payload
		},
		MODAL_INFO: (state: InquiryStateType, action: PayloadAction<ModalInfoType>) => {
			state.modalInfo = action.payload
		},

		INSERT_INQUIRY: (
			state: InquiryStateType,
			action: PayloadAction<InquiryStateType['insertInquiry']>,
		) => {
			state.insertInquiry = action.payload
		},
		INQUIRY_ERROR_MESSAGE: (
			state: InquiryStateType,
			action: PayloadAction<InquiryStateType['inquiryErrorMessage']>,
		) => {
			state.inquiryErrorMessage = action.payload
		},
	},
})

export const inquiryActions = slice.actions
export default slice.reducer
